import dayjs from 'dayjs';

const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;

export const formatTimeRemaining = (expiresAt: string): string => {
  const totalMinutes = dayjs(expiresAt).diff(dayjs(), 'minute');

  if (totalMinutes <= 0) return 'Прострочено';

  const days = Math.floor(totalMinutes / (MINUTES_IN_HOUR * HOURS_IN_DAY));
  const hours = Math.floor(
    (totalMinutes % (MINUTES_IN_HOUR * HOURS_IN_DAY)) / MINUTES_IN_HOUR,
  );
  const minutes = totalMinutes % MINUTES_IN_HOUR;

  if (days > 0) return `${days} дн ${hours} год`;
  if (hours > 0) return `${hours} год ${minutes} хв`;

  return `${minutes} хв`;
};
